import { Container, Col, Row, CardBody, Card, Button } from "reactstrap";
import ProfileEditContain from "../../Components/Jobseeker/Profile";
import { Fragment, useEffect, useState, Suspense, useRef } from "react";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import { useParams } from "react-router";
import Template1 from "../../Components/Jobseeker/ResumeTemplates/Template1/Template1";
import Template2 from "../../Components/Jobseeker/ResumeTemplates/Template2/Template2";
import Template3 from "../../Components/Jobseeker/ResumeTemplates/Template3/Template3";
import Template4 from "../../Components/Jobseeker/ResumeTemplates/Template4/Template4";
import Template5 from "../../Components/Jobseeker/ResumeTemplates/Template5/Template5";
import { useDispatch, useSelector } from "react-redux";
import { useContext } from "react";
import { PreloaderContext } from "../../_helper/Preloader/PreloaderContext";
import { fetchJobseekerDataRequest } from "../../redux/jobseeker/fetch_Jobseeker_data/actions";
import { showToast } from "../../Components/Common/Toast";
import { LOADER_TIMEOUT } from "../../Constant";
import Spinner from "../../Components/Common/Spinner";
import MyProfileEdit from "../../Components/Jobseeker/Profile/MyProfileEdit";
import EditMyProfile from "../../Components/Jobseeker/Profile/EditmyProfile";

import Select from "react-select";
import { fetchTemplatesRequest } from "../../redux/resumeTemplates/actions";
import { FiDownload } from "react-icons/fi";
import { checkTemplateLockRequest } from "../../redux/jobseeker/check_template_locked/actions";
import { FiShare2 } from "react-icons/fi";
import { shareResumeTemplateRequest } from "../../redux/jobseeker/share_resume_template/actions";
import ShareModal from "../../Components/Jobseeker/ResumeTemplates/ShareModel";
import {
  unlockTemplateRequest,
  resetUnlockTemplateMessage,
} from "../../redux/jobseeker/unlock_template/actions";
import whatsapp from "../../assets/images/Icons/whatsapp.png";
import facebook from "../../assets/images/Icons/facebook.png";
import twitter from "../../assets/images/Icons/twitter.png";
import linkedin from "../../assets/images/Icons/linkedin.png";
import { fetchJobseekerReferralRequest } from "../../redux/jobseeker/referral/actions";
import {
  idToBase64,
  base64ToId,
  showStyledCoins,
  convertFileToPdf,
  capitalizeFirstLetter,
} from "../../Components/Common/CommonFunction";
import { AuthContext } from "../../Auth/AuthContext";
import { fetchRewardsPointsRequest } from "../../redux/fetch_rewards_points/actions";
import { useLocation } from "react-router-dom";
import Editpersonal from "../../Components/Jobseeker/Resume/Editpersonal";
import Desiredcareerprofile from "../../Components/Jobseeker/Resume/Desiredcareerprofile";
import Resumeheadline from "../../Components/Jobseeker/Resume/Resumeheadline";
import Editsocialmedia from "../../Components/Jobseeker/Resume/Editsocialmedia";
import AddskillModal from "../../Components/Jobseeker/Resume/AddskillModal";
import TechnicalskillsModal from "../../Components/Jobseeker/Resume/TechnicalskillsModal";
import Workexperience from "../../Components/Jobseeker/Resume/Workexperience";
import Educationbackground from "../../Components/Jobseeker/Resume/Educationbackground";
import Worksample from "../../Components/Jobseeker/Resume/Worksample";

const ResumeScaleWrapper = ({ children, selectedTemplate }) => {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const parent = el.parentElement;
    if (!parent) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const width = entry.contentRect.width || parent.getBoundingClientRect().width;
        if (width > 0) {
          setScale(Math.min(width / 791, 1));
        }
      }
    });

    resizeObserver.observe(parent);

    const initialWidth = parent.getBoundingClientRect().width;
    if (initialWidth > 0) {
      setScale(Math.min(initialWidth / 791, 1));
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [selectedTemplate]);

  return (
    <div
      id={`resume-scale-container-${selectedTemplate}`}
      ref={containerRef}
      style={{
        zoom: scale,
        width: "791px",
        margin: "0 auto",
      }}
    >
      {children}
    </div>
  );
};

const TemplateEditPage = () => {
  const editSectionRef = useRef(null); // Create a ref for the edit section
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (editSectionRef.current) {
        const rect = editSectionRef.current.getBoundingClientRect();
        const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;
        if (isInView) {
          // If the edit section is in view, adjust the page scroll
          window.scrollTo({
            top: editSectionRef.current.offsetTop,
            behavior: "smooth", // Smooth scroll
          });
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const location = useLocation();
  const { validationMessages } = location.state || {}; // Retrieve validation messages from state
  console.log("analysisData222", validationMessages); // Logs the passed resume analysis data
  const [groupedErrors, setGroupedErrors] = useState({
    editPerson: {},
    desiredProfile: {},
    educationDetails: {},
    workExperienceDetails: {},
    urls: {},
    skills: {},
  });
  useEffect(() => {
    if (validationMessages && validationMessages.length > 0) {
      const editPersonFields = [
        "name",
        "jobseeker_email1",
        "jobseeker_phone1",
        "jobseeker_photo",
      ];
      const desiredProfileFields = ["jobseeker_preferred_job_title"];
      const educationDetailsFields = ["education_details"];
      const workExperienceDetailsFields = ["work_experience"];
      const workSampleDetailsFields = ["work_sample"];
      const urlsFields = ["urls"];
      const skillsFields = ["skills"];

      const groupedErrorsData = validationMessages.reduce(
        (acc, { field, message }) => {
          if (editPersonFields.includes(field)) {
            acc.editPerson[field] = message;
          } else if (desiredProfileFields.includes(field)) {
            acc.desiredProfile[field] = message;
          } else if (educationDetailsFields.includes(field)) {
            acc.educationDetails[field] = message;
          } else if (workExperienceDetailsFields.includes(field)) {
            acc.workExperienceDetails[field] = message;
          } else if (workSampleDetailsFields.includes(field)) {
            acc.workSampleDetails[field] = message;
          } else if (urlsFields.includes(field)) {
            acc.urls[field] = message;
          } else if (skillsFields.includes(field)) {
            acc.skills[field] = message;
          }
          return acc;
        },
        {
          editPerson: {},
          desiredProfile: {},
          educationDetails: {},
          workExperienceDetails: {},
          workSampleDetails: {},
          urls: {},
          skills: {},
        }
      );
      setGroupedErrors(groupedErrorsData);

      // Optionally, set the grouped errors in state
      // setErrors(groupedErrors);
    }
  }, [validationMessages]);
  console.log("Grouped Errors:", groupedErrors);
  const { cand_id, jobcad_id, templateId } = useParams();
  const { triggerTotalPoints } = useContext(AuthContext);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const dispatch = useDispatch();
  const { showPreloader } = useContext(PreloaderContext);
  const [templateOptions, setTemplateOptions] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(
    base64ToId(templateId)
  );
  const [selectedType, setSelectedType] = useState("");
  const [isPurchased, setIsPurchased] = useState(true);
  const [resumeShareLink, setResumeShareLink] = useState("");

  useEffect(() => {
    dispatch(fetchJobseekerReferralRequest()); // Fetch total referral coins when component mounts
  }, []);
  const jobseekerRefferalData = useSelector(
    (state) => state.referralJobseekerReducer
  );
  const referalCode = jobseekerRefferalData.data.referal_code;
  const referralLink = `${window.location.origin}${process.env.PUBLIC_URL}/jobseeker/auth/register/${referalCode}`;
  const shareOnSocialMedia = (platform) => {
    // Logic to share referral link on selected social media platform
    let shareUrl = "";
    switch (platform) {
      case "whatsapp":
        shareUrl = `https://api.whatsapp.com/send?text=Referral | Naukrify –${referralLink}`;
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer.php?u=${referralLink}`;
        break;
      case "twitter":
        shareUrl = `http://twitter.com/share?text=${referralLink}`;
        break;
      case "linkedin":
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${referralLink}`;
        break;
      default:
        break;
    }
    window.open(shareUrl, "_blank");
  };

  const handleTemplateFocus = () => {
    // This function will be called when the location dropdown is focused
    // You can trigger your API call here
    const fetchData = async () => {
      try {
        const keyword = ""; // Set your keyword value here
        dispatch(fetchTemplatesRequest(keyword));
      } catch (error) {
        // Handle any errors if necessary
      }
    };

    // Call the fetchData function when the location dropdown is focused
    fetchData();
  };

  useEffect(() => {
    handleTemplateFocus();
  }, []);

  const handleTemplateChange = (selectedOptions) => {
    setIsLoading(true);
    setSelectedTemplate(selectedOptions.value);
    setSelectedType(selectedOptions.type);
  };

  const handleShareClick = () => {
    setIsShareModalOpen(!isShareModalOpen);
  };

  useEffect(() => {
    // Dispatch share action if isPurchased is true

    // Dispatch action to share resume template
    dispatch(
      shareResumeTemplateRequest({
        template_id: idToBase64(selectedTemplate),
      })
    );
  }, [selectedTemplate]);

  useEffect(() => {
    // Set initial selected type based on the initial templateId value
    const initialSelectedType =
      templateOptions.find((option) => option.value == base64ToId(templateId))
        ?.type || "";

    setSelectedType(initialSelectedType);
  }, [templateOptions]);

  useEffect(() => {
    if (selectedType === "PREMIUM") {
      dispatch(
        checkTemplateLockRequest({
          resume_template_id: idToBase64(selectedTemplate),
        })
      );
    } else {
      setIsPurchased(true);
    }
  }, [selectedType, selectedTemplate]);

  let shareResumeTemplateReducerData = useSelector(
    (state) => state.shareResumeTemplateReducer
  );

  useEffect(() => {
    if (
      shareResumeTemplateReducerData.status &&
      shareResumeTemplateReducerData.data
    ) {
      setResumeShareLink(
        `${window.location.origin}${process.env.PUBLIC_URL}/public/preview_resume/${shareResumeTemplateReducerData.data}/${templateId}`
      );
    }
  }, [shareResumeTemplateReducerData]);

  let resumeTemplateReducerData = useSelector(
    (state) => state.resumeTemplateReducer
  );

  let templateData = resumeTemplateReducerData.data.data;

  useEffect(() => {
    templateData = templateData || [];
    // setTemplateOptions(templateData);

    const options = templateData.map((template) => ({
      value: template.value,
      label: template.label,
      type: template.type,
    }));

    setTemplateOptions(options);
  }, [templateData]);
  useEffect(() => {
    const data = {
      seeker_id: cand_id,
    };
    dispatch(fetchJobseekerDataRequest(data));
  }, []);

  const fetchJobseekerDataReducerData = useSelector(
    (state) => state.fetchJobseekerDataReducer
  );
  let profileData = [];
  if (
    !fetchJobseekerDataReducerData.isLoading &&
    fetchJobseekerDataReducerData.data.data
  ) {
    profileData = fetchJobseekerDataReducerData.data.data;
  }
  const profileDataWithCapitalizedName = profileData ? {
    ...profileData,
    jobseeker_full_name: profileData.jobseeker_full_name
      ? capitalizeFirstLetter(profileData.jobseeker_full_name)
      : profileData.jobseeker_full_name,
  } : null;

  console.log("profileData55", profileData);

  useEffect(() => {
    if (
      fetchJobseekerDataReducerData.status &&
      fetchJobseekerDataReducerData.message != ""
    ) {
      showToast("success", fetchJobseekerDataReducerData.message);
      // dispatch(resetJob());
    } else if (
      fetchJobseekerDataReducerData.status == false &&
      fetchJobseekerDataReducerData.message != ""
    ) {
      if (showPreloader) {
        setTimeout(() => {
          showToast("error", fetchJobseekerDataReducerData.message);
        }, LOADER_TIMEOUT);
      } else {
        showToast("error", fetchJobseekerDataReducerData.message);
      }
      // dispatch(resetJob());
    }
  }, [fetchJobseekerDataReducerData]);

  const checkTemplateLockedReducerData = useSelector(
    (state) => state.checkTemplateLockedReducer
  );

  useEffect(() => {
    if (
      !checkTemplateLockedReducerData.isLoading &&
      checkTemplateLockedReducerData.status
    ) {
      setIsPurchased(checkTemplateLockedReducerData.isPurchased);
      // dispatch(resetJob());
    }
  }, [checkTemplateLockedReducerData]);

  const unlockTemplateReducerData = useSelector(
    (state) => state.unlockTemplateReducer
  );

  const handleUnlockClick = () => {
    dispatch(
      unlockTemplateRequest({ template_id: idToBase64(selectedTemplate) })
    );
  };

  useEffect(() => {
    if (
      unlockTemplateReducerData.status == true &&
      unlockTemplateReducerData.message != ""
    ) {
      showToast("success", unlockTemplateReducerData.message);
      triggerTotalPoints("buy_resume", false);
      // Dispatch action to reset the message after showing the toast
      dispatch(resetUnlockTemplateMessage());
      setIsPurchased(true);
      setSelectedType("FREE");
    } else if (
      unlockTemplateReducerData.status == false &&
      unlockTemplateReducerData.message != ""
    ) {
      showToast("error", unlockTemplateReducerData.message);
      // Dispatch action to reset the message after showing the toast
      dispatch(resetUnlockTemplateMessage());
    }
  }, [unlockTemplateReducerData]);
  const fetchRewardsPointsReducerData = useSelector(
    (state) => state.fetchRewardsPointsReducer
  );

  useEffect(() => {
    if (
      !fetchRewardsPointsReducerData ||
      !fetchRewardsPointsReducerData.data ||
      !Array.isArray(fetchRewardsPointsReducerData.data) ||
      fetchRewardsPointsReducerData.data.length <= 0
    ) {
      dispatch(fetchRewardsPointsRequest());
    }
  }, []);

  const buyResumePoints =
    fetchRewardsPointsReducerData?.data?.find(
      (item) => item.name === "buy_resume"
    )?.points ?? 0;

  const [isDownloadDisabled, setIsDownloadDisabled] = useState(false); // State for download button
  const handleDownloadClick = async () => {
    console.log("isDownloadDisabled", isDownloadDisabled);
    try {
      setIsDownloadDisabled(true); // Disable the button
      const candidateName =
        (profileData && profileData.jobseeker_full_name) || "Candidate"; // Replace this with actual candidate name

      const templateName = selectedTemplate
        ? `Template${selectedTemplate}`
        : "";
      const resumeName = selectedTemplate ? `resume${selectedTemplate}` : "";
      // Load CSS content dynamically (if stored as a file)
      // const cssPath = `../../Components/Jobseeker/ResumeTemplates/${templateName}.css`;
      const cssPath = `${process.env.PUBLIC_URL}/ResumeTemplates/${templateName}.css`;

      console.log("cssPath55", cssPath);
      const cssResponse = await fetch(cssPath);
      const cssContent = await cssResponse.text();
      console.log("cssResponse", cssResponse);
      console.log("cssContent", cssContent);
      console.log("resumeName", resumeName);
      // Get the HTML content from the main tag
      const mainContent = document.getElementById(resumeName).innerHTML;
      console.log("mainContent", mainContent);

      // Combine CSS and HTML by wrapping CSS in a <style> tag
      const htmlCode = `
          <html>
            <head>
              <style>${cssContent}</style>
            </head>
            <body>
              <main>${mainContent}</main>
            </body>
          </html>
        `;
      console.log("htmlWithCSS", htmlCode);

      // Create a Blob for the HTML content (HTML file)
      const blob = new Blob([htmlCode], { type: "text/html" });

      // Create a new file object with the HTML content
      const file = new File([blob], "resume.html", { type: "text/html" });

      // Pass the file object to the convertHtmlToPdf function
      await convertFileToPdf(file, candidateName);


      setTimeout(() => {
        setIsDownloadDisabled(false); // Re-enable the button after 5 seconds
      }, 5000);
    } catch (error) {
      console.error("Error generating PDF:", error);
      showToast("error", "Failed to download the resume. Please try again.");
    }
  };

  const [TemplateComponent, setTemplateComponent] = useState(null);

  useEffect(() => {
    // Reset the component when `selectedTemplate` changes
    setTemplateComponent(null);

    // Dynamically import the template component based on `selectedTemplate`
    if (selectedTemplate) {
      setIsLoading(true); // Set loading to true when a new template is selected
      import(
        `../../Components/Jobseeker/ResumeTemplates/Template${selectedTemplate}/Template${selectedTemplate}`
      )
        .then((module) => {
          setTemplateComponent(() => module.default);
          const timeoutId = setTimeout(() => {
            setIsLoading(false); // Set loading to false after 1 minute
          }, 1000); // 60000 milliseconds = 1 minute
          // setIsLoading(false); // Set loading to false after loading the template
          return () => clearTimeout(timeoutId);
        })
        .catch((error) => {
          console.error("Error loading template:", error);
          setTemplateComponent(() => null);
          setIsLoading(false); // Set loading to false on error
        });
    }
  }, [selectedTemplate]);

  return (
    <Fragment>
      <Breadcrumbs title={"Edit Resume"} mainTitle={"Edit Resume"} />

      <Container fluid>
        <Row className="mb-4">
          <Col xs="12" className="d-flex justify-content-end mb-2">
            {isPurchased && (
              <>
                <FiShare2
                  className="share-icon"
                  title="share"
                  style={{
                    height: "25px",
                    width: "25px",
                    marginRight: "10px",
                  }}
                  onClick={handleShareClick}
                />
                {isDownloadDisabled ? (
                  <FiDownload
                    className="download-icon disabled"
                    style={{
                      height: "25px",
                      width: "25px",
                      marginRight: "10px",
                    }}
                    title="download"
                  />
                ) : (
                  <FiDownload
                    className="download-icon"
                    style={{
                      height: "25px",
                      width: "25px",
                      marginRight: "10px",
                    }}
                    onClick={handleDownloadClick}
                    title="download"
                  />
                )}
              </>
            )}
            <Select
              options={templateOptions}
              value={templateOptions.find(
                (option) => option.value == selectedTemplate
              )}
              onChange={handleTemplateChange}
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: "0px",
                  height: "30px",
                  width: "250px",
                }),
                menu: (provided) => ({
                  ...provided,
                  fontSize: "14px",
                  zIndex: 9999, // Set the z-index here
                }),
              }}
            />
          </Col>
          <Col xl="6" className="d-flex flex-column p-0 ">
            <div
              ref={editSectionRef} // Attach the ref to the edit section
              className="flex-fill p-2 custom-scrollbar"
              style={{
                height: "calc(100vh - 50px)",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {fetchJobseekerDataReducerData.isLoading ? (
                <Spinner /> // Show loader when isLoading is true
              ) : (
                <div className="" >
                  <Row>
                    <Col xl="12" className="mb-3">
                      <Card>
                        <Editpersonal
                          profileData={profileData}
                          validationMessages={groupedErrors.editPerson}
                        />

                        <Desiredcareerprofile
                          profileData={profileData}
                          validationMessages={groupedErrors.desiredProfile}
                        />

                        <Resumeheadline
                          profileData={profileData}
                          validationMessages={groupedErrors}
                        />

                        <Editsocialmedia
                          profileData={profileData}
                          validationMessages={groupedErrors.urls}
                        />
                        <AddskillModal
                          validationMessages={groupedErrors}
                          profileData={profileData}
                        />
                        <TechnicalskillsModal
                          validationMessages={groupedErrors.skills}
                          profileData={profileData}
                        />

                        <Workexperience
                          validationMessages={
                            groupedErrors.workExperienceDetails
                          }
                          profileData={profileData}
                        />

                        <Educationbackground
                          validationMessages={groupedErrors.educationDetails}
                          profileData={profileData}
                        />

                        <Worksample
                          validationMessages={groupedErrors.workSampleDetails}
                          profileData={profileData}
                        />
                      </Card>
                    </Col>
                  </Row>
                  {/* <Row>
                    <Col xl="12" className="mb-3">
                      <MyProfileEdit
                        profileData={profileData}
                        validationMessages={validationMessages}
                      />
                    </Col>
                    <Col xl="12" className="mb-3">
                      <EditMyProfile
                        profileData={profileData}
                        validationMessages={validationMessages}
                      />
                    </Col>
                    <Col xl="12" className="mb-3">
                      <Educationbackground
                        profileData={profileData}
                        validationMessages={validationMessages}
                      />
                    </Col>
                    <Col xl="12" className="mb-3">
                      <Workexperience
                        profileData={profileData}
                        validationMessages={validationMessages}
                      />
                    </Col>
                    <Col xl="12" className="mb-3">
                      <Mainskills
                        profileData={profileData}
                        validationMessages={validationMessages}
                      />
                    </Col>
                    <Col xl="12" className="mb-3">
                      <Worksample
                        profileData={profileData}
                        validationMessages={validationMessages}
                      />
                    </Col>
                  </Row> */}
                </div>
              )}
            </div>
          </Col>

          <Col xl="6" className="d-flex justify-content-center rounded" style={{ padding: "0 15px" }}>
            <div
              //className="p-3"
              style={{
                position: "relative",
                width: "100%",
                overflow: "hidden",
              }}
            >
              {/* {selectedTemplate == "1" && (
                <Template1 jobseekerData={profileData} />
              )} */}
              {/* <Suspense fallback={<div>Loading...</div>}>
                {TemplateComponent ? (
                  <TemplateComponent jobseekerData={profileData} />
                ) : (
                  <Spinner color="primary" />
                )}
              </Suspense> */}
              {isLoading ? (
                <div
                  className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                  style={{ backgroundColor: "rgba(255, 255, 255, 0.8)", zIndex: 2 }} // Optional: semi-transparent background
                >
                  <Spinner color="primary" /> {/* Centered spinner */}
                </div>
              ) : (
                TemplateComponent && (
                  <ResumeScaleWrapper selectedTemplate={selectedTemplate}>
                    <TemplateComponent jobseekerData={profileDataWithCapitalizedName} />
                  </ResumeScaleWrapper>
                )
              )}
              {selectedType === "PREMIUM" && !isPurchased && !isLoading && (
                <div
                  style={{
                    alignContent: "center",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.7)", // Adjust transparency as needed (0.7 is 70% transparent)
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1,
                  }}
                >
                  <Card className="mt-2" style={{ margin: "0 40px" }}>
                    <CardBody className="d-flex flex-column align-items-center">
                      <div className="mb-3 mb-md-0 text-center">
                        <h5>
                          Unlock this premium resume template by using{" "}
                          {showStyledCoins(buyResumePoints)} !
                        </h5>
                        <p>
                          Refer your friends to earn more points and unlock
                          other premium features!
                        </p>
                        <div className="refferal-description d-flex flex-column align-items-center">
                          <div className="share-links">
                            <span className="share-link">
                              <strong style={{ margin: "0 5px" }}>OR</strong>
                            </span>
                            <br />
                            <br />
                            <img
                              src={whatsapp}
                              className="share-link share_refferal me-2"
                              onClick={() => shareOnSocialMedia("whatsapp")}
                              aria-label="Whatsapp"
                              alt="whatsapp"
                              style={{
                                width: "25px",
                                height: "25px",
                                cursor: "pointer",
                              }}
                            />
                            <img
                              src={facebook}
                              className="share-link share_refferal me-2"
                              onClick={() => shareOnSocialMedia("facebook")}
                              aria-label="Facebook"
                              alt="facebook"
                              style={{
                                width: "25px",
                                height: "25px",
                                cursor: "pointer",
                              }}
                            />
                            <img
                              src={twitter}
                              className="share-link share_refferal me-2"
                              onClick={() => shareOnSocialMedia("twitter")}
                              aria-label="Twitter"
                              alt="twitter"
                              style={{
                                width: "25px",
                                height: "25px",
                                cursor: "pointer",
                              }}
                            />
                            <img
                              src={linkedin}
                              className="share-link share_refferal me-2"
                              onClick={() => shareOnSocialMedia("linkedin")}
                              aria-label="Linkedin"
                              alt="linkedin"
                              style={{
                                width: "25px",
                                height: "25px",
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mt-3">
                        <Button color="warning" onClick={handleUnlockClick}>
                          UNLOCK THIS RESUME
                        </Button>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>

      <ShareModal
        isOpen={isShareModalOpen}
        toggle={() => setIsShareModalOpen(!isShareModalOpen)}
        resumeShareLink={resumeShareLink}
      />
    </Fragment>
  );
};

export default TemplateEditPage;
